module.exports = __webpack_public_path__ + "static/media/bullet.97a9d08a.png";